// extracted by mini-css-extract-plugin
module.exports = {"orangespan":"OrangeSpan_orangespan__IUDRY","textspan":"OrangeSpan_textspan__MJqS7"};